import { Component, OnInit } from '@angular/core';
import { FaqDto } from '../../../models/faq-dto';
import { FirestoreService } from '../../../services/firestore/firestore.service';
import { SharedService } from '../../../services/shared/shared.service';
import { FormsModule, NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-faqs',
  standalone: true, // if you want it standalone
  imports: [
    FormsModule,
    CommonModule
  ],
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.css'] // ✅ plural
})
export class FaqsComponent implements OnInit {
  faqs: FaqDto[] = [];
  currentFaq: FaqDto = { question: '', answer: '' };
  editMode = false;
  showSpinner=true;
  constructor(
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private firestoreService: FirestoreService
  ) {}

  ngOnInit(): void {
    this.getAllFaqs();
  }

  getAllFaqs() {
    this.firestoreService.getAll('faqs').subscribe({
      next: (data) => {
        this.faqs = data;
        this.showSpinner=false;
      },
      error: (err) => {
        this.showSpinner=false;

        console.error(err);
      }
    });
  }

  saveFaq(form: NgForm) {
    if (form.invalid) return;
    this.spinner.show();

    const saveOrUpdate = () => {
      if (this.editMode && this.currentFaq.id) {
        this.firestoreService.update('faqs', this.currentFaq.id, this.currentFaq).subscribe({
          next: () => {
            this.spinner.hide();
            this.resetForm();
            this.getAllFaqs();
            this.sharedService.handleSuccess("FAQ updated successfully");
          },
          error: (err) => {
            console.error('Error updating FAQ:', err);
            this.spinner.hide();
          }
        });
      } else {
        this.firestoreService.add('faqs', this.currentFaq).subscribe({
          next: () => {
            this.spinner.hide();
            this.resetForm();
            this.getAllFaqs();
            this.sharedService.handleSuccess("FAQ added successfully");
          },
          error: (err) => {
            console.error('Error adding FAQ:', err);
            this.spinner.hide();
          }
        });
      }
    };

    saveOrUpdate();
  }

  editFaq(faq: FaqDto) {
    this.currentFaq = { ...faq };
    this.editMode = true;
    const modal = new (window as any).bootstrap.Modal(document.getElementById('faqModal'));
    modal.show();
  }

  deleteFaq(id: string) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This action will delete the FAQ permanently.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.firestoreService.delete('faqs', id).subscribe({
          next: () => {
            this.spinner.hide();
            this.getAllFaqs();
            Swal.fire('Deleted!', 'The FAQ has been deleted.', 'success');
          },
          error: (err) => {
            this.sharedService.handleError(err,"Error","There was an error deleting the FAQ.")
          }
        });
      }
    });
  }

  resetForm() {
    this.currentFaq = { question: '', answer: '' };
    this.editMode = false;
  }
}
